import { getMinutesAndSecondsStringFromSeconds } from '../../DateTime';
import { isValidObject, isValidString } from '../../Validity';
import { fullPenaltyOffence } from './LacrosseStatDescription';

export const lacrossePlayerGameDetails = (playerId: string, goals: any[], highlightsPerPlayer: any[], penalties: any[]) => {
    const details: any[] = [];
    if (isValidObject(goals)) {
        goals.forEach((goal: any) => {
            if (goal.team === 'our' && isValidString(goal.scorerId) && goal.scorerId === playerId) {
                details.push(`Goal: ${goal.period.toUpperCase()} - ${getMinutesAndSecondsStringFromSeconds(goal.timeInSeconds)}`);
            }
            if (goal.team === 'our' && isValidString(goal.assist1Id) && goal.assist1Id === playerId) {
                details.push(`Assist1: ${goal.period.toUpperCase()} - ${getMinutesAndSecondsStringFromSeconds(goal.timeInSeconds)}`);
            }
            if (goal.team === 'our' && isValidString(goal.assist2Id) && goal.assist2Id === playerId) {
                details.push(`Assist2: ${goal.period.toUpperCase()} - ${getMinutesAndSecondsStringFromSeconds(goal.timeInSeconds)}`);
            }
        });
    }

    if (isValidObject(highlightsPerPlayer)) {
        highlightsPerPlayer.forEach((highlight: any) => {
            if (highlight.type === 'shots' && isValidString(highlight.playerId) && highlight.playerId === playerId) {
                details.push(`Shots: ${highlight.number}`);
            }
            if (highlight.type === 'blocks' && isValidString(highlight.playerId) && highlight.playerId === playerId) {
                details.push(`Blocks: ${highlight.number}`);
            }
            if (highlight.type === 'turnOvers' && isValidString(highlight.playerId) && highlight.playerId === playerId) {
                details.push(`Turn Overs: ${highlight.number}`);
            }
            if (highlight.type === 'groundBalls' && isValidString(highlight.playerId) && highlight.playerId === playerId) {
                details.push(`Ground Balls: ${highlight.number}`);
            }
            if (highlight.type === 'saves' && isValidString(highlight.playerId) && highlight.playerId === playerId) {
                details.push(`Saves: ${highlight.number}`);
            }
        });
    }

    if (isValidObject(penalties)) {
        penalties.forEach((penalty: any) => {
            if (penalty.team === 'our' && isValidString(penalty.playerId) && penalty.playerId === playerId) {
                details.push(`Penalty: ${penalty.period.toUpperCase()} - ${getMinutesAndSecondsStringFromSeconds(penalty.timeInSeconds)} - Penalty Time: ${getMinutesAndSecondsStringFromSeconds(penalty.penaltyTimeInSeconds)} - Type: ${penalty.type} - Offence: ${fullPenaltyOffence(penalty.offence)}`);
            }
            return null;
        });
    }

    return details;
};
